export const enum IDP_APP {
  COMMON = 'COMMON'
}

export const enum EndpointKey {
  FLOW_CODE_URL = 'FLOW_CODE_URL'
}

export const enum Libraries {
  STATIC_QR_CODE = 'STATIC_QR_CODE'
}
